// Every service required for dashboard display
import axios from "axiosConfig";
// import axiosInstance from './axiosConfig';

const getDCAsettings = async () => {
  const { data } = await axios.get("api/dcasetting/");
  console.log("dcaSettings", data);
  return data;
};

const dcaSettingsService = {
  getDCAsettings,
};

export default dcaSettingsService;
